import { createAction, handleActions } from 'redux-actions';
import { takeLatest, call } from 'redux-saga/effects';
import * as prodAPI from '../../lib/api/prodapi';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';

// 상품 상세  
const [DETAIL, DETAIL_SUCCESS, DETAIL_FAILURE] = createRequestActionTypes(
    'user/DETAIL',
);
const LOCINFO = 'prod/LOCINFO';

// Action 정의 
export const detailAction = createAction(DETAIL, (locinfo) => {
    return { locinfo }
});
export const setLocInfo = createAction(LOCINFO);

// Make Saga I/F
const detailSaga = createRequestSaga(DETAIL, prodAPI.getProdDetail);

export function* userDetailSaga() {
    yield takeLatest(DETAIL, detailSaga);
}

/**
 * 리덕스 모듈 초기값 
 */
const initialState = {
    status: null,
    proddata: null,
    locinfo: null
};

/**
 * 리덕스 액션 연결 
 */
const prodDetailReducer = handleActions(
    {
        // Data 초기화 
        [DETAIL]: (state) => {
            return ({
                ...state,
                status: null,
                proddata: null,
                locinfo: null,
            })
        },
        // 성공할 경우
        [DETAIL_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                status: payload.code * 1,
                proddata: payload.dataList[0]
            })
        },
        // 실패할 경우 
        [DETAIL_FAILURE]: (state, { payload: error }) => ({
            ...state,
            status: 500,
            proddata: error
        }),
        [LOCINFO]: (state, { payload: locinfo }) => ({
            ...state,
            locinfo: locinfo,
        })
    },
    initialState,
);

export default prodDetailReducer;